<section id="icon">
    <div class="icon" [style.background]="'url('+icon+')'" [style.width]="width" [style.height]="height" [style.margin]="margin"></div>
</section>
